import React, { useRef } from "react";
import "../style/Services.css";

import s1 from "../assets/multipletruckservice.png";
import s2 from "../assets/lathmachenary.png";
import s3 from "../assets/velding.png";
import s4 from "../assets/rehab.jpeg";
import s5 from "../assets/200mt.png";
import s6 from "../assets/spareparts.png";
import s7 from "../assets/spareparts.png";

const services = [
  {
    title: "MULTI BRANDED TRUCK SERVICES",
    desc: "Complete servicing and maintenance for all major truck brands ensuring reliability and performance.",
    image: s1,
  },
  {
    title: "LATHE MACHINERY JOBS & MACHINE FABRICATION",
    desc: "Precision lathe machining, custom fabrication and heavy engineering works.",
    image: s2,
  },
  {
    title: "AUTO DENTING, WELDING & BODY PAINTING",
    desc: "Professional denting, welding and premium body painting services.",
    image: s3,
  },
  {
    title: "RE-HAB WORK OF EXCAVATORS & CONCRETE PUMPS",
    desc: "Complete rehabilitation and overhaul of excavators, transit mixers and concrete pumps.",
    image: s4,
  },
  {
    title: "LINE BORING & ENGINE RE-BUILDING",
    desc: "High-accuracy line boring, engine rebuilding, drum & disc boring with facings.",
    image: s5,
  },
  {
    title: "200 MT HYDRAULIC PRESS & HOSE CRIMPING",
    desc: "Heavy-duty hydraulic press works and hydraulic hose crimping services.",
    image: s6,
  },
  {
    title: "SPARE PARTS & LUBRICANTS",
    desc: "Spare parts for MAN, EICHER, TATA, MAHINDRA with AdBlue and industrial lubricants.",
    image: s7,
  },
];

export default function Services() {
  const scrollRef = useRef(null);

  const scrollLeft = () => {
    scrollRef.current.scrollBy({
      left: -380,
      behavior: "smooth",
    });
  };

  const scrollRight = () => {
    scrollRef.current.scrollBy({
      left: 380,
      behavior: "smooth",
    });
  };

  return (
    <div className="services-page" id="services">
      <h1 className="services-heading">Our Services</h1>

      <div className="carousel-wrapper">

        <button className="scroll-btn left" onClick={scrollLeft}>
          &#10094;
        </button>

        <div className="horizontal-carousel" ref={scrollRef}>
          {services.map((service, index) => (
            <div className="service-card" key={index}>
              <div className="service-image">
                <img src={service.image} alt={service.title} />
              </div>

              <div className="service-content">
                <h2>{service.title}</h2>
                <p>{service.desc}</p>
              </div>
            </div>
          ))}
        </div>

        <button className="scroll-btn right" onClick={scrollRight}>
          &#10095;
        </button>

      </div>
    </div>
  );
}